/**
 * @group Components
 * @summary <blockquote>FullscreenIcon icon component.</blockquote>
 * @example
 * ```tsx
 * <FullscreenIcon />
 * ```
 */
export const FullscreenIcon = ({ size = 16 }: { size?: number }) => (
        <svg
          height={size}
          strokeLinejoin="round"
          viewBox="0 0 16 16"
          width={size}
          style={{ color: 'currentcolor' }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 5.25V6H2.5V5.25V2.5H5.25H6V1H5.25H2C1.44772 1 1 1.44772 1 2V5.25ZM5.25 14.9994H6V13.4994H5.25H2.5V10.7494V9.99939H1V10.7494V13.9994C1 14.5517 1.44772 14.9994 2 14.9994H5.25ZM15 10V10.75V14C15 14.5523 14.5523 15 14 15H10.75H10V13.5H10.75H13.5V10.75V10H15ZM10.75 1H10V2.5H10.75H13.5V5.25V6H15V5.25V2C15 1.44772 14.5523 1 14 1H10.75Z"
            fill="currentColor"
          />
        </svg>
      );